import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalConsignmentService } from 'src/app/_services/global-consignment.service';
import { GlobalRequisitionService } from 'src/app/_services/global-requisition.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
    selector: 'app-approval-configuration',
    templateUrl: './approval-configuration.component.html',
    styleUrls: ['./approval-configuration.component.scss'],
    standalone: false
})
export class ApprovalConfigurationComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  requisitionData: any[] = [];
  type:any
  configDetails: any;
  saveUrl: string;
  submitTouched: boolean;
  approvalOrder: any;
  constructor( 
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private globalRequisitionService:GlobalRequisitionService,
    private globalConsignmentService:GlobalConsignmentService,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private modalService2: ModalServiceService,
    ) { 
        super();
      }
  
    ngOnInit(): void {
      this.saveUrl = this.type == 'consignment' ? 'consignment-approval-settings' : 'requisition-approval-settings';
      this.getLanguageData();
    }
  
    getLanguageData() {
      this.push(
        this.languageTranslateService.wordSrc$.subscribe((data) => {
          if (Object.keys(data).length != 0) {
            this.translate = data;
            this.getConfigApprovalData();
          }
        })
      );
    }
  
    getConfigApprovalData() {
      this.push(
        this.globalConsignmentService.getApprovalConfig(this.saveUrl).subscribe((res:any) => {
          this.configDetails = res.body;
          console.log(this.configDetails)
          if(this.type == 'consignment'){
         this.configDetails.requisitionLevel1MustApproveBeforeLevel2 = this.configDetails.consignmentLevel1MustApproveBeforeLevel2
          this.configDetails.requisitionLevel2MustApproveBeforeLevel1 = this.configDetails.consignmentLevel2MustApproveBeforeLevel1
          this.configDetails.requisitionApprovalsCanBeDoneInAnyOrder = this.configDetails.consignmentApprovalsCanBeDoneInAnyOrder
          this.configDetails.requisitionReceiverLevel1GroupApproves = this.configDetails.consignmentReceiverLevel1GroupApproves
          this.configDetails.requisitionReceiverLevel2GroupApproves = this.configDetails.consignmentReceiverLevel2GroupApproves
          this.configDetails.requisitionRequesterManagingGroupApproves = this.configDetails.consignmentRequesterManagingGroupApproves
          this.setApprovalOrder()
          
          }else{
            this.setApprovalOrder()
          }


          
        })
      )
    }
    setApprovalOrder() {
      console.log(this.configDetails)
      if(this.configDetails.requisitionLevel1MustApproveBeforeLevel2){
        this.approvalOrder = 'requisitionLevel1MustApproveBeforeLevel2';
      }else if(this.configDetails.requisitionLevel2MustApproveBeforeLevel1){
        this.approvalOrder = 'requisitionLevel2MustApproveBeforeLevel1';
      }else if(this.configDetails.requisitionApprovalsCanBeDoneInAnyOrder){
        this.approvalOrder = 'requisitionApprovalsCanBeDoneInAnyOrder';}
      }
    /******************************************** Radio Change ******************************************/
    radioChange() {
      console.log('Radio button value changed:', this.approvalOrder);
      // Add your logic here
    }
    setData() {
        if(this.configDetails.requisitionReceiverLevel1GroupApproves && this.configDetails.requisitionReceiverLevel2GroupApproves){
          this.approvalOrder = 'requisitionApprovalsCanBeDoneInAnyOrder' 
        }else{
          this.approvalOrder =null
        }
    }
      //==================================================================== This function is used to save the approval data
      saveConsignmentApproval() {
         // Check if at least one checkbox is selected
        if (
          !this.configDetails.requisitionRequesterManagingGroupApproves &&
          !this.configDetails.requisitionReceiverLevel1GroupApproves &&
          !this.configDetails.requisitionReceiverLevel2GroupApproves
        ) {
          this.errorUtil.setErrorMessage(
            400,
            null,
            'At least 1 option must be selected. All 3 can be selected',
            'error',
            3000
          );
          return; // Stop the save operation
        }
        this.submitTouched = true;
        this.spinner.show();
        var req=null
        if(this.configDetails.requisitionReceiverLevel1GroupApproves && this.configDetails.requisitionReceiverLevel2GroupApproves){
          this.configDetails.requisitionLevel1MustApproveBeforeLevel2 = this.approvalOrder == 'requisitionLevel1MustApproveBeforeLevel2' ? true : false;
          this.configDetails.requisitionLevel2MustApproveBeforeLevel1 = this.approvalOrder == 'requisitionLevel2MustApproveBeforeLevel1' ? true : false;
          this.configDetails.requisitionApprovalsCanBeDoneInAnyOrder = this.approvalOrder == 'requisitionApprovalsCanBeDoneInAnyOrder' ? true : false;
        }else{
          this.configDetails.requisitionLevel1MustApproveBeforeLevel2 = false;
          this.configDetails.requisitionLevel2MustApproveBeforeLevel1 = false;
          this.configDetails.requisitionApprovalsCanBeDoneInAnyOrder = false;
        }
        if(this.type == 'consignment'){
         req= {
            "id": this.configDetails.id,
            "consignmentRequesterManagingGroupApproves": this.configDetails.requisitionRequesterManagingGroupApproves,
            "consignmentReceiverLevel1GroupApproves": this.configDetails.requisitionReceiverLevel1GroupApproves,
            "consignmentReceiverLevel2GroupApproves": this.configDetails.requisitionReceiverLevel2GroupApproves,
            "consignmentLevel1MustApproveBeforeLevel2": this.configDetails.requisitionLevel1MustApproveBeforeLevel2,
            "consignmentLevel2MustApproveBeforeLevel1": this.configDetails.requisitionLevel2MustApproveBeforeLevel1,
            "consignmentApprovalsCanBeDoneInAnyOrder": this.configDetails.requisitionApprovalsCanBeDoneInAnyOrder
        }
      }else{
        req=this.configDetails
      }
        console.log(req)
        this.push(
          this.globalConsignmentService.updateApprovalConfig(req,this.saveUrl).subscribe((res:any) => {
            console.log(res)
            this.spinner.hide();
            if(res.status == 201 || res.status == 200){
              this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully ,  null, 'success',1000);
              
              this.modalRef.hide();
              
             } else {
               const title = this.errorUtil.processErrorTitle(res.error,this.translate)
               this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
               this.submitTouched = false;
             }
            },
            (err) => {
              this.submitTouched = false;
              this.spinner.hide()
             const title = this.errorUtil.processErrorTitle(err.error,this.translate)
             this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
            
          })
        )
      }

      
    openModal(modalView: any, data : any): void {
      this.modalService2.openModal(modalView, data);
    }

    ngOnDestroy(): void {
      super.ngOnDestroy();
    }
    push(obs: any) {
      super.push(obs);
    }

}
